import { render, staticRenderFns } from "./province-echart.vue?vue&type=template&id=39b1fa2d&"
import script from "./province-echart.vue?vue&type=script&lang=js&"
export * from "./province-echart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports